'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["style", "onClick"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var A11yDiv = function A11yDiv(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    onClick = _ref.onClick,
    attrs = _objectWithoutProperties__default["default"](_ref, _excluded);
  if (!onClick) {
    return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
      style: style
    }, attrs));
  }
  return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    role: "button",
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      var keyCode = e.nativeEvent.code;
      if (keyCode === 'Enter' || keyCode === 'Space') {
        onClick(e);
      }
    },
    tabIndex: 0
  }, attrs, {
    style: _objectSpread({
      cursor: 'pointer'
    }, style)
  }));
};

exports["default"] = A11yDiv;
